import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class DocumentManagement {
  // 位号绑定关联关系
  static async saveTagFileAssociationList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/std/TagFileAssociation/save-tag-file-association-list',
        payload
      )
    )
    return Callback(err, res)
  }
  // 上传zip文件
  static async uploadZipFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/upload-zip-file', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  static async getTagListByCodeOrName(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Tag/list-by-code-or-name?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取文档批量关联进度
  static async getDocumentBatchRelationProgress(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Common/redis-progress/${payload}`)
    )
    return Callback(err, res)
  }
  // 批量上传关联文档
  static async batchDynamicTableData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/TagFileAssociation/batch-file-association-tag-v2', payload)
    )
    return Callback(err, res)
  }
  // 批量上传关联文档(分片)
  static async chunkDynamicUpload(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/Document/local-chunk-upload/${payload.md5}/${payload.chunk}`,
        payload.file
      )
    )
    return Callback(err, res)
  }
  // 批量上传关联文档(合并)
  static async chunkDynamicUploadComplete(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/local-merge-files', payload)
    )
    return Callback(err, res)
  }
  // 批量上传关联文档(校验)
  static async chunkDynamicUploadCheck(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/local-get-chunk/${payload}`)
    )
    return Callback(err, res)
  }
  // 新增或修改文档和模板属性
  static async createOrUpdateDocument(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/document-tag-create-or-update', payload)
    )
    return Callback(err, res)
  }
  // 关联关系导入模板
  static async getTagFileAssociationTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/std/TagFileAssociation/download-template', {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 下载文档文件
  static async downloadDocumentFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/download_document_file', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  static async documentExport(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/export', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 获取文档列表（默认文件）
  static async getDocumentDefaultFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/document/handover/withdefaultfile?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 导出文档默认文件
  static async exportDefaultFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/document/export/defaultfile', payload)
    )
    return Callback(err, res)
  }
  // 文档默认文件导入模板
  static async downloadDefaultFileTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/document/template_download/defaultfile')
    )
    return Callback(err, res)
  }
  // 文档默认文件导入
  static async uploadDefaultFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/document/import/defaultfile', payload.formData)
    )
    return Callback(err, res)
  }
  // 获取文档模板属性数据源
  static async getDocumentAtrrTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/DocumentClass/get_attribute_template_list')
    )
    return Callback(err, res)
  }
  // 获取已关联的模板数据
  static async getRelativeTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/DocumentClass/get_documentclass_attribute_template_list/${payload.id}`
      )
    )
    return Callback(err, res)
  }
  // 获取文档树
  static async getDocumentClassTree(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/documentclass/handover/tree', payload)
    )
    return Callback(err, res)
  }
  // 新增文档类别
  static async addDocumentClass(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/DocumentClass/save_document_class', payload)
    )
    return Callback(err, res)
  }
  // 修改文档类别
  static async updateDocumentClass(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/DocumentClass/update_document_class', payload)
    )
    return Callback(err, res)
  }
  // 对象移交管理部分
  // 对象移交管理列表数据
  static async getTagList(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/Tag?${qs.stringify(payload)}`))
    return Callback(err, res)
  }
  // 获取上级位号集合
  static async getTagParentList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Tag/parents?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 对象移交管理列表数据——包含是否关联模型信息
  static async getTagIsConModelList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/handover/related_model?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 对象移交管理删除数据项
  static async deleteObjTrans(payload) {
    const [err, res] = await To(wizStandardInstance.delete('/api/std/Tag/many', payload))
    return Callback(err, res)
  }
  // 获取对象移交的位号树
  static async getTagTree(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/handover/tag_tree?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 通过code获取位号
  static async getTagByCode(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/handover/getbycode?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 对象移交创建位号
  static async addObjTrans(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Tag', payload))
    return Callback(err, res)
  }
  // 对象移交修改
  static async updetObjTrans(payload) {
    const [err, res] = await To(wizStandardInstance.put(`/api/std/Tag/${payload.id}`, payload))
    return Callback(err, res)
  }
  // 对象移交管理位号导入
  static async importObjTrans(payload, formData) {
    const [err, res] = await To(
      wizStandardInstance.post(`/api/std/Tag/import?${qs.stringify(payload)}`, formData, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 对象移交位号导出
  static async exportObjTrans(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Tag/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 动态表格导出数据
  static async exportDynamicTableData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/export-dynamic-table-data', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 动态模板下载
  static async downloadTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/download-template', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 动态模板导入
  static async importDynamicTableData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/import-dynamic-table-data', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 批量上传关联文档
  static async batchDynamicTableData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/TagFileAssociation/batch-file-association-tag-v2', payload)
    )
    return Callback(err, res)
  }
  // 批量上传关联文档(分片)
  static async chunkDynamicUpload(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/Document/local-chunk-upload/${payload.md5}/${payload.chunk}`,
        payload.file
      )
    )
    return Callback(err, res)
  }
  // 批量上传关联文档(合并)
  static async chunkDynamicUploadComplete(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/local-merge-files', payload)
    )
    return Callback(err, res)
  }
  // 批量上传关联文档(校验)
  static async chunkDynamicUploadCheck(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/local-get-chunk/${payload}`)
    )
    return Callback(err, res)
  }
  // 对象移交修改数据回显
  static async editObjTransList(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/Tag/${payload.id}`))
    return Callback(err, res)
  }
  // 关联关系-查询位号与文件的通用查询接口
  static async relationObjTrans(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/tag/handover/relation?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 关联关系-表格查询
  static async relationObjTable(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/TagFileAssociation?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 关联关系-新增文件和对象的关联
  static async relationObjAdd(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/TagFileAssociation', payload))
    return Callback(err, res)
  }
  // 关联关系-编辑文件和对象的关联
  static async relationObjEdit(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(`/api/std/TagFileAssociation/${payload.id}`, payload)
    )
    return Callback(err, res)
  }
  // 关联关系-删除位号-文件的关联关系
  static async relationObjDelete(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/TagFileAssociation/many', { data: payload })
    )
    return Callback(err, res)
  }
  // 关联关系-导出位号-文件的关联关系
  static async relationObjExport(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/TagFileAssociation/export', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 关联关系-导入位号-文件的关联关系
  static async relationObjImport(formData) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/TagFileAssociation/import', formData, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 关联关系-位号、文件位号关联模板下载
  static async getTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Tag/download-template?${qs.stringify(payload)}`, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 关联关系-获取文档列表
  static async getDocumentIdList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 关联关系-新增操作中的获取文件（根据文档id查询文件列表）
  static async getFileList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/get_document_files?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 文档移交部分
  // 文档移交-查询文档列表通用接口
  static async getDocumentList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/document/handover?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 文档移交-获取文档目录树
  static async getDocumentTree(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Folder/tree-nodes?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 文档移交-新增目录树节点(批量)
  static async addTreeNode(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Folder/many', payload))
    return Callback(err, res)
  }
  // 文档移交-获取文档文件夹路径
  static async getDocumentFolderPath(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Document/handover/folder/path?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 文档移交-删除表格列表项删除
  static async documentDelete(payload) {
    const [err, res] = await To(wizStandardInstance.delete('/api/std/Document/many', payload))
    return Callback(err, res)
  }
  // 按文档类型ID获取动态模板及明细
  static async getTemplateByClassId(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Document/handover/template?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 文档移交-创建文档
  static async addDocument(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Document', payload))
    return Callback(err, res)
  }
  // 文档移交-修改时根据id回显
  static async getDocumentEdite(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/Document/handover/${payload.id}`))
    return Callback(err, res)
  }
  // 文档移交-修改文档
  static async editeDocument(payload) {
    const [err, res] = await To(wizStandardInstance.put(`/api/std/Document/${payload.id}`, payload))
    return Callback(err, res)
  }
  // 文档移交-导出
  static async getDocumentExport(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/Document/handover/export', payload))
    return Callback(err, res)
  }
  // 文档移交-导入
  static async getDocumentImport(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/import', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 文档移交管理-下载移交模板
  static async getDocumentTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/download-template', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 文档移交-文档升版
  static async upGrade(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Document/handover/update_document_version', payload)
    )
    return Callback(err, res)
  }
  // 文档移交-历史版本列表
  static async getHistoryTab(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`api/document/handover/hostory_document?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 文档移交-历史版本关联文件下载
  static async downLoadHistoryFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Document/handover/download_obsolete_document', payload)
    )
    return Callback(err, res)
  }
  // 文档移交-下载文档所关联的文件
  static async downLoadFile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Document/handover/download_document', payload)
    )
    return Callback(err, res)
  }
  // 关联关系右侧点击确定添加关联关系的操作
  static async confirmIntelligenceTag(payload) {
    // const [err, res] = await To(
    //   wizStandardInstance.post('/api/DocumentFile/intelligencefiletagasync', payload)
    // )
    const [err, res] = await To(wizStandardInstance.post('/api/std/TagFileAssociation', payload))
    return Callback(err, res)
  }
  // 文档移交-获取单条流程信息
  static async getFlowInfoById(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Document/handover/flow?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 文档移交-根据doucumentId获取文件详情
  static async getDocumentDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/multi_model?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  static async getTagListByCodeOrName(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Tag/list-by-code-or-name?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 对象移交-获取单条流程信息
  static async getFlowTagInfoById(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Tag/handover/flow?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 个人工作台-文档移交-调用获取下一个步骤的用户和信息接口
  static async getTransNextStepInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/FlowTask/GetSendStepsNew', payload)
    )
    return Callback(err, res)
  }
  // 个人工作台-文档移交-获取执行人下拉列表数据
  static async getExecutorList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCoreApi/Organize/GetOneLevel`,
        payload
      )
    )
    return Callback(err, res)
  }
  // 对象移交-发起对象移交流程
  static async sendTagHandover(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/Tag/handover/flow', payload))
    return Callback(err, res)
  }
  // 文档移交-发起文档移交流程
  static async sendDocHandover(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/Document/handover/flow', payload))
    return Callback(err, res)
  }
  // 个人工作台-文档移交-执行流程接口
  static async ExecuteTask(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCoreApi/FlowTask/InitFlowNew`,
        payload
      )
    )
    return Callback(err, res)
  }
  // 发送流程
  static async SendFlowNew(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCoreApi/FlowTask/SendFlowNew`,
        payload
      )
    )
    return Callback(err, res)
  }
  // 个人工作台-获取当前流程
  static async getCurrentFlow(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/FlowTask/GetCurrentFlow', payload)
    )
    return Callback(err, res)
  }
  // 文档移交-流程结束(成功时候调用)
  static async finishDocFlow(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Document/handover/flow/finish_flow/${payload.instanceId}`)
    )
    return Callback(err, res)
  }
  // 对象移交-流程结束(成功时候调用)
  static async finishTagFlow(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Tag/handover/flow/finish_flow/${payload.instanceId}`)
    )
    return Callback(err, res)
  }
  // 完成流程时调用
  static async finishFlow(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/HandoverFlow/finish_flow', payload))
    return Callback(err, res)
  }
  // 流程退回时调用
  static async rejectFlow(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/HandoverFlow/deny_flow', payload))
    return Callback(err, res)
  }
  // 个人工作台-获取流程的实例组列表
  static async getGroupTasks(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/FlowTask/GetGroupTasks', payload)
    )
    return Callback(err, res)
  }
  // 文档移交-流程退回
  static async getRejectFlow(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Document/handover/flow/reject_flow/${payload.instanceId}`)
    )
    return Callback(err, res)
  }
  // 对象移交-流程退回
  static async getTagRejectFlow(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/Tag/handover/flow/reject_flow/${payload.instanceId}`)
    )
    return Callback(err, res)
  }
  // 个人工作台-获取流程退回步骤
  static async getBackSteps(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/Flow/GetBackSteps', payload)
    )
    return Callback(err, res)
  }
  // 个人工作台-获取代办任务待办流程列表
  static async getWBNoComplete(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/FlowTask/GetUnFinishedTasks', payload)
    )
    return Callback(err, res)
  }
  // 个人工作台-获取代办任务已办流程列表
  static async getWBComplete(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/FlowTask/GetFinishedTasks', payload)
    )
    return Callback(err, res)
  }
  // 个人工作台-获取已发任务流程列表
  static async getWBSend(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/FlowTask/GetSubmittedTasks', payload)
    )
    return Callback(err, res)
  }
  // 获取文档文件夹路径(不带权限，兼容老功能)
  static async getFolderList(params) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Document/handover/folder/path/no_permission?${qs.stringify(params)}`
      )
    )
    return Callback(err, res)
  }
  // 个人工作台-根据项目不同，获取对应的flowid
  static async GetFlows(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/FlowTask/GetFlowsNew', params)
    )
    return Callback(err, res)
  }
  // 个人工作台-已发送，撤回流程
  static async getBackFlows(params) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCoreApi/FlowTask/CancelTask`,
        params
      )
    )
    return Callback(err, res)
  }
  // 个人工作台-已发送-调用业务接口(让审核中，变为未移交)
  static async getDenyFlow(params) {
    const [err, res] = await To(wizStandardInstance.post('/api/HandoverFlow/deny_flow', params))
    return Callback(err, res)
  }
  // 安全考核单通过or删除
  static async updateIllegal(params) {
    const [err, res] = await To(wizStandardInstance.post('/api/rpt_camera/pass_or_delete', params))
    return Callback(err, res)
  }
  // 安全考核单下载
  static async downloadIllegal(params) {
    const [err, res] = await To(wizStandardInstance.post('/api/rpt_camera/download', params))
    return Callback(err, res)
  }
  // 获取违章知识通知单
  static async getIllegal(params) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/rpt_camera/get_rpt_camera_notice/${params}`)
    )
    return Callback(err, res)
  }
  // 个人工作台-已发送-调用业务业务接口（让未移交变为审核中）
  static async updateFlow(params) {
    const [err, res] = await To(wizStandardInstance.post('/api/HandoverFlow/update_flow', params))
    return Callback(err, res)
  }
  // 个人工作台-已发送-调用业务接口(让审核中变为未移交)
  static async getAutoEndFlow(params) {
    const [err, res] = await To(wizStandardInstance.post('/api/HandoverFlow/auto_end_flow', params))
    return Callback(err, res)
  }
  // 个人工作台-任务超时处理轮询接口
  static async getDelayTask(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/FlowTask/GetDelayTask', params)
    )
    return Callback(err, res)
  }
  // 文档数据管理-删除(撤回)操作
  static async documentDataDelete(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/document/handover/revoke', payload))
    return Callback(err, res)
  }
  // 对象数据管理-删除（撤回）操作
  static async tagDataDelete(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/tag/handover/revoke', payload))
    return Callback(err, res)
  }
  // 工作台-判断流程是否完成
  static async IsFlowComplete(params) {
    const [err, res] = await To(
      wizStandardInstance.post('/RoadFlowCoreApi/FlowTask/IsFlowComplete', params)
    )
    return Callback(err, res)
  }
  // 获取文件关联文件信息(文档清单)
  static async getfilejoinfilelist(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/get_file_document_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取文件关联文件信息
  static async getFileReleFileList(payload) {
    if (!payload.standardId) {
      return
    }
    const [err, res] = await To(
      wizStandardInstance.post(
        `/api/std/ObjectAssociation/get-file-rele-file-list?standardId=${payload.standardId}`,
        payload
      )
    )
    return Callback(err, res)
  }
  // 获取文件可以关联的文件列表
  static async getFileOkReleFileList(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ObjectAssociation/get-file-ok-rele-file-list', payload)
    )
    return Callback(err, res)
  }
  // 删除文件关联文件
  static async fileJoinfile(payload) {
    const [err, res] = await To(wizStandardInstance.delete(`/api/std/ObjectAssociation/${payload}`))
    return Callback(err, res)
  }
  // 保存文件关联文件
  static async addFileJoinfile(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ObjectAssociation/create-file-join-file', payload)
    )
    return Callback(err, res)
  }
  // 高级搜索
  static async advancedSearch(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 直接上传文件，变成文档
  static async uploadFiles(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/upload_files_to_document', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 初始化流程实例接口
  static async initFlowInstance(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCoreApi/FlowTask/InitFlowInstance`,
        payload
      )
    )
    return Callback(err, res)
  }
  // 更新流程实例
  static async updateFlowInstance(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        `${currentEnv.VUE_APP_FLOW_SERVER}/RoadFlowCoreApi/FlowTask/UpdateFlowInstance`,
        payload
      )
    )
    return Callback(err, res)
  }
  // 根据位号类别获取关联和未关联的文档类别
  static async getJoinDocumentClass(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/TagClass/handover/tagclass/getjoindocumentclass?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取位号树
  static async getTagClassTree(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/tagclass/handover/tree', payload))
    return Callback(err, res)
  }
  // 文档类别关联位号类别-位号类别管理编辑或者新增点击确定提交操作
  static async documentClassJoinTagClass(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/TagClass/handover/tagclass/documentclassjointagclass', payload)
    )
    return Callback(err, res)
  }
  // 从西站获取ht链路图的已移交数据
  static async getPublishDraw(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/congxi_document/get_ht_document_list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 从西站 发布ht绘图的请求
  static async publishDraw(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/Congxi_Document/publish_ht_document', payload)
    )
    return Callback(err, res)
  }
  // 通过MD5获取文件信息
  static async getFileInfo(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/file/getfilecontentasync/${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取位号信息，包含动态模板数据
  static async getTagsDetails(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/tag/tags?${qs.stringify(payload)}`))
    return Callback(err, res)
  }
  // 通过模板属性获取文档
  static async getDocumentByTempAttr(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/document/handover/get_lianlu_document?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取文档文件夹路径下的节点(树状)
  static async getDocPathByFolderId(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/Folder?${qs.stringify(payload)}`))
    return Callback(err, res)
  }
  // 新增+修改模型文档列表 支持多个文件
  static async addAndUpdateDocumentFileList(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/document/reserveplan', payload))
    return Callback(err, res)
  }
  // 获取文档关联JSON数据
  static async getSceneJsonData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/reserve_model_relation/${payload.id}`)
    )
    return Callback(err, res)
  }
  // 保存文档关联JSON数据
  static async saveSceneJsonData(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/reserve_model_relation', payload))
    return Callback(err, res)
  }
  // 文件排序
  static async updateFileOrder(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Document/set_file_seq', payload))
    return Callback(err, res)
  }
  // 获取实体类型动态表属性
  static async getTagsList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/class-type-table-header?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取实体类别动态表属性
  static async getDynamicList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/dynamic-table-group-header?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 获取引用数据
  static async getReferenceColumnData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/reference-column-data?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 保存动态表数据
  static async saveDynamicTableData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/save-dynamic-table-data', payload)
    )
    return Callback(err, res)
  }
  // 获取动态表单数据
  static async getDynamicTableData(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/dynamic-table-data-by-id?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
  // 根据id获取实体类型名称
  static async getClassTypeNameById(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass/class-type-name-by-id?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 删除动态数据（type：0是实体数据管理，1是类型，2是实体对象，3是实体文档）
  static async deleteDynamicData(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/StdClassData/delete-dynamic-data', { data: payload })
    )
    return Callback(err, res)
  }
  // 获取扩展属性下拉列表
  static async getExtendClassList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassExtendClass/get-list?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取扩展属性数据
  static async getExtendData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassExtendClass/get-extend-data', payload)
    )
    return Callback(err, res)
  }
  // 获取历史版本数据
  static async getHistoryData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/dynamic-table-version-data-by-code', payload)
    )
    return Callback(err, res)
  }
  // 实体文档升版
  static async setVersion(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/set-version', payload)
    )
    return Callback(err, res)
  }
  // 智能推荐数据查询
  static async smartRecommendQuery(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/ElasticSearchSource/smart-recommend-query', payload)
    )
    return Callback(err, res)
  }
  // 实体上传附件
  static async uploadAttachments(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/std_class_upload_files', payload)
    )
    return Callback(err, res)
  }
  // 软删除文件
  static async deleteDocumentFiles(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/std/Document/soft-delete-file', { data: payload })
    )
    return Callback(err, res)
  }
  // 实体属性上传的附件列表
  static async documentUploadFiles(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Document/upload-files', payload))
    return Callback(err, res)
  }
  // 关联关系-位号、文件位号关联模板下载
  static async batchDownLoadAssociationTemplate(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/TagFileAssociation/batch-batch-file-association-tag-template?${qs.stringify(
          payload
        )}`,
        {
          responseType: 'blob',
        }
      )
    )
    return Callback(err, res)
  }
  // 批量关联导入
  static async batchFileAssociationTag(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/TagFileAssociation/batch-file-association-tag', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 重解关联
  static async refreshTagFileAssociation(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/TagFileAssociation/refresh-tag-file-association', payload)
    )
    return Callback(err, res)
  }
  // 分片上传文件
  static async chunkUpload(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/Document/chunk-upload', payload))
    return Callback(err, res)
  }
  // 上传文件合并分片文件 返回上传结果文件
  static async chunkUploadComplete(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/chunk-upload-complete', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
  // 上传文件合并分片文件 返回文件信息
  static async chunkUploadCompleteV2(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/chunk-upload-complete-v2', payload)
    )
    return Callback(err, res)
  }
  // 关联关系上传合并分片文件
  static async chunkUploadRelationComplete(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/Document/chunk-upload-relation-complete', payload)
    )
    return Callback(err, res)
  }
  // 获取文档详情
  static async getDocumentDetailById(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/Document/get-document-detail?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取实体属性列表
  static async getEntityPropertyList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClassAttribute?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取动态属性数据
  static async getDynamicPropertyData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/dynamic-table-paged-result', payload)
    )
    return Callback(err, res)
  }
  // 文档检入检出
  static async documentCheckInOut(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/StdClassData/document-check-in-out', payload)
    )
    return Callback(err, res)
  }
}
